import { Button } from 'uikit'
import { useStore } from '@tanstack/react-store'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { bannerListStore } from 'shared/store'
import { paramsToTableStateAdapter, tableStateToParamsAdapter } from 'shared/utils/sortAdapter'
import { ReactTablePaged } from 'uikit/ReactTable'
import {
  Container,
  FilterHeader,
  FilterStack,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { columns } from './BannerList.config'
import { ListFilter } from './ListFilter'
import { useFetchBanners } from './services/useFetchBanners'

export const List = () => {
  const history = useHistory()
  const { data, isLoading } = useFetchBanners()
  const store = useStore(bannerListStore)

  const onChangeFilters = useCallback((state) => {
    const { group } = state
    bannerListStore.setState((state) => ({ ...state, group }))
  }, [])

  const onSortingChange = useCallback((state) => {
    const sortState = tableStateToParamsAdapter(state)
    bannerListStore.setState((state) => ({ ...state, bannerSortOrder: sortState }))
  }, [])

  return (
    <Container>
      <SnippetsContainer indentTop={122}>
        <SnippetsContainerMain>
          <ReactTablePaged
            storageId="banner-list"
            onRowClick={(item) => history.push(`/services/banners/show/${item.id}`)}
            isLoading={isLoading}
            columns={columns}
            data={data || []}
            totalPages={0}
            initialState={{
              sorting: paramsToTableStateAdapter(store.bannerSortOrder),
            }}
            onSortingChange={onSortingChange}
          />
        </SnippetsContainerMain>
        <SnippetsContainerRightAside>
          <FilterHeader>
            <Button
              width="100%"
              onClick={() => history.push(`/services/banners/new`)}
              colorPalette="orange"
            >
              Создать
            </Button>
          </FilterHeader>
          <FilterStack>
            <ListFilter initialState={store} onChange={onChangeFilters} />
          </FilterStack>
        </SnippetsContainerRightAside>
      </SnippetsContainer>
    </Container>
  )
}
